<!-- Start::menu item (lg+) -->
<div class="hidden lg:block">
  <h2 class="fw-bold" style="font-size: 14px">Contáctanos</h2>
  <hr class="my-2" style="background-color: #646462" />

  <div>
    <ul>
      <li>
        Llámanos a la línea de atención al cliente<br />
        @if(country == 'pe'){
        <div class="row">
          <p class="mt-3 mb-0"><b>Para ventas:</b></p>
          <div class="col-6 py-0 d-flex align-items-center">
            <a [href]="'tel:' + config.company.formattedPhone">
              <img
                class="me-2"
                src="../../../../../assets/svg/14.svg"
                style="width: 20px; height: 20px"
                alt="fono"
              />
              {{ config.company.phone }}
            </a>
            <p class="ms-2 mb-0" id="opcion" style="white-space: nowrap">
              (Opción 1)
            </p>
          </div>
          <div class="col-6 py-0 text-start">
            <a
              [href]="
                'https://api.whatsapp.com/send?phone=' +
                config.company.formattedWhatsapp
              "
              target="_blank"
            >
              <picture>
                <source
                  srcset="assets/images/WhatsApp-peru.png"
                  type="image/webp"
                />
                <source
                  srcset="assets/images/boton_wsp_02.png"
                  type="image/png"
                />
                <img
                  src="assets/images/boton_wsp_02.png"
                  class="me-1"
                  style="width: 160px"
                  alt="whatsapp"
                />
              </picture>
            </a>
          </div>
        </div>
        <div class="row">
          <p class="mb-0"><b>Para servicio al cliente:</b></p>
          <div class="col-6 py-0 d-flex align-items-center">
            <a [href]="'tel:' + config.company.formattedPhone">
              <img
                class="me-2"
                src="../../../../../assets/svg/14.svg"
                style="width: 20px; height: 20px"
                alt="fono"
              />
              {{ config.company.phone }}
            </a>
            <p class="ms-2 mb-0" id="opcion" style="white-space: nowrap">
              (Opción 2)
            </p>
          </div>
        </div>
        } @else{
        <div class="row mt-0">
          <p class="mt-3 mb-0"><b>Para ventas:</b></p>
          <div class="col-6 py-0 d-flex align-items-center">
            <a [href]="'tel:' + config.company.formattedPhone">
              <img
                class="me-2"
                src="../../../../../assets/svg/14.svg"
                style="width: 20px; height: 20px"
                alt="fono"
              />
              {{ config.company.phone }}
            </a>
            <p class="ms-2 mb-0" id="opcion" style="white-space: nowrap">
              (Opción 1)
            </p>
          </div>
          <div class="col-6 py-0 d-flex align-items-center">
            <a
              [href]="
                'https://api.whatsapp.com/send?phone=' +
                config.company.formattedWhatsapp
              "
              target="_blank"
            >
              <picture>
                <source
                  srcset="assets/images/boton_wsp_02.webp"
                  type="image/webp"
                />
                <source
                  srcset="assets/images/boton_wsp_02.png"
                  type="image/png"
                />
                <img
                  src="assets/images/boton_wsp_02.png"
                  class="me-1"
                  style="width: 140px"
                  alt="whatsapp"
                />
              </picture>
            </a>
          </div>
        </div>
        <div class="row">
          <p class="mb-0"><b>Para servicio al cliente:</b></p>
          <div class="col-6 py-0 d-flex align-items-center">
            <a [href]="'tel:' + config.company.formattedPhone">
              <img
                class="me-2"
                src="../../../../../assets/svg/14.svg"
                style="width: 20px; height: 20px"
                alt="fono"
              />
              {{ config.company.phone }}
            </a>
            <p class="ms-2 mb-0" id="opcion" style="white-space: nowrap">
              (Opción 3)
            </p>
          </div>
        </div>
        }
      </li>
      <li class="mt-3">
        <div class="row">
          <div class="py-0">
            <img
              class="me-2"
              src="../../../../../assets/svg/15.svg"
              style="width: 20px; height: 20px"
              alt="horario"
            />
            @if(country == 'pe') { Horario: Lu a Vi 8:30 a 18:00 hrs.<br />

            }@else{ Horario: Lu a Vi 9:00 a 18:30 hrs.<br />
            }
            <span style="margin-left: 95px">Sáb 9:00 a 13:00 hrs.</span>
          </div>
        </div>
      </li>
      <li class="mt-3">
        <div class="m-0">
          <div class="py-0">
            <img
              class="me-2"
              src="../../../../../assets/svg/06-solid.svg"
              style="width: 23px; height: 30px"
              alt="direccion"
            />
            {{ config.company.address }}.
          </div>
        </div>
      </li>
      <li class="mt-3">
        <div class="text-center">
          <div
            class="col-12 lg:col-4 py-0 flex justify-content-center"
            (click)="Contacto()"
            style="
              cursor: pointer;
              border: 2px solid white;
              border-radius: 15px;
              padding: 8px;
            "
          >
            <i
              class="fa-solid fa-envelope"
              style="margin-right: 10px; font-size: 20px"
            ></i>
            Contacto
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>
<!-- End::menu item (lg+) -->

<!-- Start::menu item (xs, sm y md) -->
<div class="block lg:hidden">
  <div
    class="col-12 py-0"
    data-bs-toggle="collapse"
    data-bs-target="#contactanos"
    [attr.aria-expanded]="terminos"
    aria-controls="contactanos"
  >
    <div class="row">
      <div class="col-8 py-0 flex justify-content-start">
        <h3 class="fw-bold text-center">Contáctanos</h3>
      </div>
      <div class="col-4 py-0 flex justify-content-end">
        <i class="fa-solid fa-chevron-down"></i>
      </div>
    </div>
  </div>

  <hr class="my-2" style="background-color: #646462" />

  <div
    class="collapse multi-collapse"
    [ngClass]="terminos ? 'show' : ''"
    id="contactanos"
  >
    <ul>
      <li class="ps-3">
        Llámanos a la línea de atención al cliente<br />
        <div class="row">
          <div class="col-5 py-0 flex align-items-center">
            <a [href]="'tel:' + config.company.formattedPhone">
              <img
                class="me-2"
                src="../../../../../assets/svg/14.svg"
                style="width: 20px; height: 20px"
                alt="fono"
              />
              {{ config.company.phone }}
            </a>
          </div>
          <div class="col-6 py-0 text-start">
            <a
              [href]="
                'https://api.whatsapp.com/send?phone=' +
                config.company.formattedWhatsapp
              "
              target="_blank"
            >
              <!-- <img class="me-1" src="../../../../../assets/images/boton_wsp_02.png" style="width: 140px" /> -->

              @if(country == 'pe') {
              <picture>
                <source
                  srcset="assets/images/WhatsApp-peru.png"
                  type="image/webp"
                />
                <source
                  srcset="assets/images/boton_wsp_02.png"
                  type="image/png"
                />
                <img
                  src="assets/images/boton_wsp_02.png"
                  class="me-1"
                  style="width: 160px"
                  alt="whatsapp"
                />
              </picture>
              } @else{
              <picture>
                <source
                  srcset="assets/images/boton_wsp_02.webp"
                  type="image/webp"
                />
                <source
                  srcset="assets/images/boton_wsp_02.png"
                  type="image/png"
                />
                <img
                  src="assets/images/boton_wsp_02.png"
                  class="me-1"
                  style="width: 140px"
                  alt="whatsapp"
                />
              </picture>
              }
            </a>
          </div>
        </div>
      </li>
      <li class="mt-3 ps-3">
        <div class="row">
          <div class="col-12 py-0">
            <img
              class="me-2"
              src="../../../../../assets/svg/15.svg"
              style="width: 20px; height: 20px"
              alt="horario"
            />
            <br />Horario: Lu a Vi 8:30 a 18:00 hrs.<br />
            <span style="margin-left: 95px">Sab 9:00 a 13:00 hrs.</span>
          </div>
        </div>
      </li>
      <li class="mt-3 ps-3">
        <div class="row">
          <div class="col-12 py-0">
            <img
              class="me-2"
              src="../../../../../assets/svg/06-solid.svg"
              style="width: 23px; height: 30px"
              alt="direccion"
            />
            {{ config.company.address }}.
          </div>
        </div>
      </li>
      <li class="mt-3 ps-3">
        <div class="row text-center">
          <div
            class="ms-3 col-4 py-0 flex justify-content-center"
            (click)="Contacto()"
            style="
              cursor: pointer;
              border: 2px solid white;
              padding: 8px;
              border-radius: 15px;
            "
          >
            <i
              class="fa-solid fa-envelope"
              style="margin-right: 10px; font-size: 20px"
            ></i>
            Contacto
          </div>
        </div>
      </li>
    </ul>
    <hr class="my-2" style="background-color: #646462" />
  </div>
</div>
<!-- End::menu item (xs, sm y md) -->
